(async () => {
    if (!customElements.get("new-featured-banner-block")) {
        class FeaturedBannerBlock extends HTMLElement {
            constructor() {
                super();
                this.swiperElement = this.querySelector("[data-featured-banner-swiper]");
                this.swiperOptions = {
                    loop: true,
                    autoplay: false,
                    slidesPerView: 1.6,
                    observer: false,
                    threshold: 10,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.5,
                            spaceBetween: 15
                        },
                        768: {
                            slidesPerView: 2.5,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerView: 3.5,
                            spaceBetween: 20
                        },
                        1440: {
                            slidesPerView: 1.6,
                            spaceBetween: 20
                        }
                    }
                };
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions
                        }
                    }
                }
                if (Shopify.designMode && this.swiperInstance) {
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperInstance.update()
                    }))
                }
                this.init()
            }
            init() {
                this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)
            }
        }
        window.FeaturedBannerBlock = FeaturedBannerBlock;
        customElements.define("new-featured-banner-block", FeaturedBannerBlock)
    }
})();
//# sourceMappingURL=new-featured-banner-block.js.map